/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
// import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
// import Table from "react-bootstrap/Table";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React examples
import DefaultNavbar from "bachrosenComponents/bachNavbar";
import CenteredFooter from "bachrosenComponents/centeredFooter";
// import HorizontalBlogCard from "examples/Cards/BlogCards/HorizontalBlogCard";
import BachHeader from "bachrosenComponents/bachHeader";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

// Images
import bgImage from "assets/images/home1.jpg";

// import presidentsArray from "assets/texts/presidents.json";

function ImpressumSite() {
  const impressum = `
  <h2>Impressum</h2>

  <h4>Angaben gem&auml;&szlig; &sect; 5 TMG</h4><br>
  <p><strong>Brauchtumsverein Bachrose Bietingen e.V.</strong><br />
  &emsp;  88605 Sauldorf-Bietingen <br /><br />
  
  &emsp; Vereinsregister: VR 170 <br />
  &emsp; Registergericht: Amtsgericht Sigmaringen </p>

  <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE999999999 ?? <br>
  Wirtschaftsidentifikationsnummer </p>
  
  <p><strong>Vertreten durch:</strong><br />
  Zunftmeister <br>
  &emsp; Manuel Müller<br>
  &emsp; Mainwanger Straße 17 <br>
  &emsp; 88605 Sauldorf-Boll <br>
  &emsp; Tel.: 01739557430 <br>
  &emsp; E-Mail: manuel.mueller325(at)outlook.de </p>
  
  <p><strong>Redaktionell verantwortlich:</strong><br>
  &emsp; Sina Müller<br />
  &emsp; E-Mail: info(at)bachrose-bietingen.de</p>
  
  <b>Haftungshinweis:</b><br>
  Mit dem Urteil vom 12. September 1999 – 312 O 85/99 – „Haftung für Links“ – hat das Landgericht Hamburg entschieden, dass man durch die Anbringung eines Links
  die Inhalte der gelinkten Seite gegebenenfalls mit zu verantworten hat. Dieses kann – so das Landgericht Hamburg – nur dadurch verhindert werden, indem man
  sich ausdrücklich von diesen Inhalten distanziert.
  
  Deshalb dieser Hinweis:
  Im Internetauftritt des Brauchtumsvereins Bachrose Bietingen e.V.  sind Links zu anderen Seiten im Internet gelegt. Für alle diese Links gilt: Der Herausgeber hat
  keinerlei Einfluss auf Gestaltung und Inhalte der gelinkten Seiten. Deshalb distanziert sich der Herausgeber hiermit ausdrücklich von allen Inhalten aller
  gelinkten Seiten im  Internetauftritt des Brauchtumsverein Bachrose Bietingen e.V.  Diese Erklärung gilt für alle
  im Programm angezeigten Links und für alle Inhalte der Seiten, auf die verlinkt ist.
  `;

  // <p>Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz: DE999999999 ?? <br>
  // Wirtschaftsidentifikationsnummer </p>

  return (
    <>
      <MKBox position="fixed" top="0.5rem" width="100%">
        <DefaultNavbar routes={routes} dark info center />
      </MKBox>
      <BachHeader image={bgImage} title="Impressum" />
      {/* <MKBox
        minHeight="75vh"
        width="100%"
        sx={{
          backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
            `${linearGradient(
              rgba(gradients.dark.main, 0.6),
              rgba(gradients.dark.state, 0.6)
            )}, url(${bgImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "grid",
          placeItems: "center",
        }}
      >
        <MKTypography
          align="center"
          variant="h1"
          color="white"
          sx={({ breakpoints, typography: { size } }) => ({
            [breakpoints.down("md")]: {
              fontSize: size["3xl"],
            },
          })}
        >
          Impressum
        </MKTypography>
      </MKBox> */}
      <Card
        sx={{
          // p: 2,
          mx: { xs: 2, lg: 3 },
          mt: -8,
          mb: 4,
          pt: 8,
          pb: 8,
          boxShadow: ({ boxShadows: { xxl } }) => xxl,
        }}
      >
        <Container>
          <MKTypography
            variant="body2"
            color="text"
            dangerouslySetInnerHTML={{ __html: impressum }}
          />
        </Container>
      </Card>
      <MKBox px={1} mt={6}>
        <CenteredFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default ImpressumSite;
